import * as categories from '../categories';
import { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, PERFORMANCE } from '../constants';

const dict = {
	'c1': STRICTLY_NECESSARY,
	'c2': PERFORMANCE,
	'c3': FUNCTIONAL,
	'c4': TARGETING,
};

export const set = (ids) => {
	const newCats = (Array.isArray(ids) ? ids : ids.split(',')).map(id => dict[id]).filter(a => !!a);
	categories.set(newCats);
};
